import { numberCutFormat as numberCutFormatFunc } from '../utils';

const numberCutFormat = (num) => {
    if (!Number.isNaN(num)) {
        return numberCutFormatFunc(num);
    }

    return num;
};

export default numberCutFormat;
